'use strict'

export default
{
	"rootFolder": "",
    "assets": ""
} 
